import { RetentionPolicy, RetentionRunResult } from '../RetentionPolicy';

interface ApplicationRetentionProps {
  setSuccessMessage: (message: string) => void;
  setErrorMessage: (message: string) => void;
  active?: boolean;
}

export function ApplicationRetention(props: ApplicationRetentionProps) {
  return (
    <RetentionPolicy
      {...props}
      endpoint="/api/application_retention/1"
      subject="Application"
      minimumMonths={1}
      runButtonLabel="Run application purge"
      warning={(months, cutoff) =>
        `Applications older than ${months} months (before ${cutoff}) and all dependent records will be permanently deleted.`
      }
      confirmation={(cutoff) => (
        <>
          <p>You are about to permanently delete all applications created before {cutoff}.</p>
          <p>This also deletes career, education, ranking, competency, manager approval, graduation pledge, and triad records tied to those applications.</p>
        </>
      )}
      formatRunSuccess={(result: RetentionRunResult) =>
        `Deleted ${result.purgedCount} applications and ${result.dependentRowsDeleted ?? 0} dependent records.`
      }
    />
  );
}
